export default import.meta.ROLLDOWN_FILE_URL_51U_IjbwI0YVanm6PKWK7Q